<loading-animation size="small"
                   *ngIf="!carriers && !devices">
</loading-animation>
<form class="device-selector-form"
      [ngClass.gt-xs]="'limit-width'"
      [formGroup]="cellularDeviceForm"
      *ngIf="communicationHardware && carriers && devices">

    <mat-form-field *ngIf="communicationHardware">
        <mat-label>Communication Hardware</mat-label>
        <mat-select [formControlName]="selectedCommunicationHardwareName"
                    (selectionChange)="updateCellularDeviceCommunicationHardware()">
            <mat-option [value]="null">
                {{ noHardware }}
            </mat-option>

            <mat-option *ngFor="let hardware of communicationHardware"
                        [value]="hardware">
                {{ hardware.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="currentDeviceTypes?.length">
        <mat-label>Device Type</mat-label>
        <mat-select [formControlName]="selectedDeviceTypeName"
                    (selectionChange)="updateCellularDeviceType()">
            <mat-option [value]="null">
                {{ noDevice }}
            </mat-option>

            <mat-option *ngFor="let device of currentDeviceTypes"
                        [value]="device">
                {{ device.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="currentCarriers?.length">
        <mat-label>Cellular Carrier</mat-label>
        <mat-select [formControlName]="selectedCellularCarrierName"
                    (selectionChange)="updateCellularCarrier()">
            <mat-option *ngFor="let carrier of currentCarriers"
                        [value]="carrier">
                {{ carrier.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <!-- To map Identifier to mobileTypeId you have to take data from selectedCellularCarrier and map index to form array -->
    <ng-container *ngIf="selectedCellularCarrierControl?.value && cellularDeviceInfoIdentifiersNameArray?.controls.length"
                  [formArrayName]="cellularDeviceInfoIdentifiersName">
        <mat-form-field
                        *ngFor="let deviceInfoIdentifier of cellularDeviceInfoIdentifiersNameArray.controls; let index = index">
            <mat-label>{{ selectedCellularCarrierControl.value.mobileIdTypes[index].name }}</mat-label>
            <input matInput
                   [formControlName]="index"
                   (keyup)="updateCellularIdentifier(index)" />
            <mat-error *ngIf="cellularDeviceInfoIdentifiersNameArray.at(index).hasError('pattern')">
                {{ getValidationText('pattern', index)}}
            </mat-error>
            <mat-error
                       *ngIf="cellularDeviceInfoIdentifiersNameArray.at(index).hasError('maxlength')">
                {{ getValidationText('maxlength', index)}}
            </mat-error>
            <mat-error
                       *ngIf="cellularDeviceInfoIdentifiersNameArray.at(index).hasError('minlength')">
                {{ getValidationText('minlength', index)}}
            </mat-error>
        </mat-form-field>
    </ng-container>
    <mat-form-field
                    *ngIf="selectedCellularCarrierControl?.value as selectedCellularCarrier">
        <mat-label>Assignment</mat-label>
        <mat-select [formControlName]="selectedCellularDeviceAssignmentName"
                    (selectionChange)="updateCellularDeviceAssignment()">
            <mat-option *ngFor="let assignment of assignments"
                        [value]="assignment">
                {{ assignment.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <ng-container
                  *ngIf="selectedCellularCarrierControl?.value as selectedCellularCarrier">
        <mat-form-field *ngIf="selectedCellularCarrier.vendors.length > 0">
            <mat-label>Vendor</mat-label>

            <mat-select [formControlName]="selectedCellularVendorName"
                        (selectionChange)="updateVendor()">
                <mat-option *ngFor="let vendor of selectedCellularCarrier.vendors"
                            [value]="vendor">
                    {{ vendor.displayName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>
    <div *ngIf="showActivation">
        <cl-cellular-device-activation *ngIf="selectedCellularCarrierControl?.value?.vendors?.length"
                                       [allowedMobileIdTypes]="cellularDeviceInfo.allowedMobileIdTypes"
                                       [canRequestActivation]="canRequestActivation"
                                       [deviceIdentifierMap]="cellularDeviceInfo.updatedCellularDeviceInfoIdentifiers"
                                       [isCellularDeviceValid]="true"
                                       [jobNumber]="jobNumber"
                                       [locationId]="locationId"
                                       [moduleId]="moduleId"
                                       [vendor]="selectedCellularVendorControl.value"
                                       [isActive]="cellularDeviceStatus?.isActive"
                                       [carrier]="selectedCellularCarrierControl.value">
        </cl-cellular-device-activation>
        <cl-cellular-device-deactivation *ngIf="canRequestDeactivation"
                                         [allowedMobileIdTypes]="cellularDeviceInfo.allowedMobileIdTypes"
                                         [canRequestDeactivation]="canRequestDeactivation"
                                         [cellularDeviceStatus]="cellularDeviceStatus"
                                         [carrier]="selectedCellularCarrierControl.value"
                                         [deviceIdentifierMap]="cellularDeviceInfo.updatedCellularDeviceInfoIdentifiers"
                                         [jobNumber]="jobNumber"
                                         [locationId]="locationId"
                                         [moduleId]="moduleId"
                                         [vendor]="selectedCellularVendorControl.value">
        </cl-cellular-device-deactivation>
        <br />
        <cl-cellular-device-status *ngIf="canUpdateCellularDeviceStatus"
                                   (onCellularDeviceStatusChange)="onUpdateCellularDeviceStatus.emit($event)"
                                   [moduleId]="moduleId">
        </cl-cellular-device-status>
    </div>
</form>
